import { FC } from 'react';

import StudioNavigation from '../../studio/StudioNavigation';
import Layout, { LayoutProps } from '../Layout';

export interface StudioLayoutProps extends LayoutProps {}

const StudioLayout: FC<StudioLayoutProps> = props => (
  <Layout renderNavigation={() => <StudioNavigation />} {...props} />
);

export default StudioLayout;
